export const HINGED_WARDROBES_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Распашной шкаф',
    addText: 'в цвете акация',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1076,
  },
  {
    displayedName: 'Распашные шкафы и тумба',
    addText: 'под ТВ для гостиной',
    mediaMainPhoto: ['2.jpg/2.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1078,
  },
  {
    displayedName: 'Распашной шкаф',
    addText: 'в сером цвете',
    mediaMainPhoto: ['3.jpg/3.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1079,
  },
  {
    displayedName: 'Распашные шкафы',
    addText: 'в цвете серый камень',
    mediaMainPhoto: ['4.jpg/4.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1034,
  },
  {
    displayedName: 'Распашной шкаф',
    addText: 'для прихожей в сером цвете',
    mediaMainPhoto: ['5.jpg/5.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1035,
  },
  {
    displayedName: 'Распашной шкаф',
    addText: 'для спальни',
    mediaMainPhoto: ['6.jpg/6.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1036,
  },
  {
    displayedName: 'Распашные шкафы',
    addText: 'в белом цвете',
    mediaMainPhoto: ['7.jpg/7.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1037,
  },
  {
    displayedName: 'Прихожая',
    addText: 'с зеркалом',
    mediaMainPhoto: ['8.jpg/8.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1060,
  },
  {
    displayedName: 'Распашные шкафы',
    addText: 'для детской',
    mediaMainPhoto: ['9.jpg/9.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1061,
  },
  {
    displayedName: 'Распашной шкаф',
    addText: 'для прихожей',
    mediaMainPhoto: ['10.jpg/10.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1062,
  },
  {
    displayedName: 'Стенка для гостиной',
    addText: 'в бело-сером цвете',
    mediaMainPhoto: ['11.jpg/11.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1063,
  },
  {
    displayedName: 'Матовый шкаф',
    addText: 'с зеркалом',
    mediaMainPhoto: ['12.jpg/12.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1074,
  },
  {
    displayedName: 'Шкаф для спальни',
    addText: 'в теплых тонах',
    mediaMainPhoto: ['13.jpg/13.jpg'],
    productName: '',
    style: 'hinged-wardrobes',
    rating: 1075,
  },
];